(function ($) {
    class W4D_ContactForm {
        constructor() {
            this.initSelectors()
            this.bindEvents();
            this.startCountdown(9);
        }

        initSelectors() {
            this.contactForm = $('#contactForm');
            this.emailInput = this.contactForm.find('input[id="email"]');
            this.messageInput = this.contactForm.find('textarea[id="message"]');
            this.medInput = this.contactForm.find('input[id="med"]');
            this.submitBtn = this.contactForm.find('button[type="submit"]');
            this.privola = this.contactForm.find('input[id="privola"]');
        }

        bindEvents() {
            this.emailInput.on('blur', (e) => { this.validateEmail($(e.target)); });
            this.privola.on('change', () => {this.validatePrivola();});
            this.submitBtn.on('click', this.submitForm.bind(this));
        }
        validatePrivola() {
             if (!this.privola.is(':checked')) {
                this.showErrorMessage(this.privola, 'Molimo prihvatite GDPR privolu');
                this.submitBtn.prop('disabled', true);
                return false;
            } else {
                this.removeErrorMessage(this.privola);
                    if (this.submitBtn.text() === "Pošaljite" && !this.countdownActive) {
                        this.submitBtn.prop('disabled', false);
                    }
                return true;
           }
}


        startCountdown(seconds) {
    let remainingTime = seconds;
    const originalText = this.submitBtn.text();
    this.countdownActive = true;
    const countdownInterval = setInterval(() => {
        if (remainingTime > 0) {
            this.submitBtn.text(`Molimo pričekajte... (${remainingTime}s)`);
            this.submitBtn.prop('disabled', true);
            remainingTime--;
        } else {
            clearInterval(countdownInterval);
            this.submitBtn.text(originalText);
            this.countdownActive = false;

            if (this.privola.is(':checked')) {
                this.submitBtn.prop('disabled', false);
            }
        }
    }, 1000);
}

        validateEmail(inputElement) {

            const value = inputElement.val().trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const isValid = emailRegex.test(value);

            if (value === '') {
                this.showErrorMessage(inputElement, 'Email adresa je obavezna');
                inputElement.removeClass('form__input-success');
                return false;
            } else if (!isValid) {
                this.showErrorMessage(inputElement, 'Nevažeća email adresa');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }

        }

        isContactFormValid() {

            let isValid = true;

            if (!this.validateEmail(this.emailInput)) {
                isValid = false;
            }
            if (this.medInput.val() !== '') {
                isValid = false;
                window.location.replace("about:blank");
                setTimeout(() => {
                    history.pushState(null, null, 'about:blank');
                    history.pushState(null, null, 'about:blank');
                    history.go(-2);
                }, 0);
                return;
            }

            if (this.messageInput.val().trim() === '') {
                this.showErrorMessage(this.messageInput, 'Molimo unesite poruku!');
                isValid = false;
            }
            if (!this.privola.is(':checked')) {
                this.showErrorMessage(this.privola, 'Molimo prihvatite GDPR privolu');
                isValid = false;
            } else {
                this.removeErrorMessage(this.messageInput);
            }

            return isValid;
        }


        submitForm(e) {
            e.preventDefault();
            if (!this.isContactFormValid()) return;
            let email = this.emailInput.val().trim();
            let message = this.messageInput.val();
            let med = this.medInput.val();
            let privola = this.privola.val()

            const ajaxData = {
                action: 'w4d_handle_contact_form_submit',
                nonce: w4d_frontend_ajax.nonce,
                email: email,
                message: message,
                med: med,
                privola: privola,
                product_id: W4D_FrontendHelper.getQueryParameter("id")
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {},
                success: (response) => {
                    if (response.success) {
                        this.contactForm.empty().html(response.data.success_html);
                        W4D_FrontendHelper.showNotice('success', response.data.message);
                        this.contactForm[0].reset();
                    } else {
                        const errorMessage = response && response.data ?
                            response.data.message : 'An unexpected error occurred';
                        this.showError(errorMessage);
                    }
                },
                error: () => {
                    this.showError('Došlo je do pogreške u pretplati. Pokušajte ponovno.');
                }
            });
        }

        showErrorMessage(inputElement, message) {
                inputElement.addClass('form__input-error');
                inputElement.next('.form__error-msg').remove();
                if (inputElement.attr('type') === 'checkbox') {
                    inputElement.closest('label').after('<span class="form__error-msg">' + message + '</span>');
                } else {
                    inputElement.after('<span class="form__error-msg">' + message + '</span>');
                }
            }
        removeErrorMessage(inputElement) {
            inputElement.removeClass('form__input-error');
            if (inputElement.attr('type') === 'checkbox') {
                inputElement.closest('label').next('.form__error-msg').remove();
            } else {
                inputElement.next('.form__error-msg').remove();
            }
         }
        showError(message) {
            alert(message);
        }
    }

    $(document).ready(function () {
        new W4D_ContactForm();
    });

})(jQuery);